/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA assigned-reviews React view (inbox)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsAssignedRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'inbox.reviews.assigned',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(InboxReviewsAssignedRoute);
